import { Module } from '../Module';
import { IOAuthCredentialTypeInfo } from '../ServerApi/types/IOAuthCredential';
import { IOAuthCredentialDisplayStrings, IOAuthCredentialsService } from '../services/OAuthCredentialsService';

export interface ICredentialTypeFilter {
  (credentialTypeInfo: IOAuthCredentialTypeInfo): string;
}

Module.instance().filter('credentialType', [
  '$translate',
  'OAuthCredentialsService',
  ($translate: ng.translate.ITranslateService, oAuthCredentialsService: IOAuthCredentialsService): ICredentialTypeFilter => {
    return (credentialTypeInfo: IOAuthCredentialTypeInfo) => {
      const displayStrings: IOAuthCredentialDisplayStrings = oAuthCredentialsService.getDisplayStrings(credentialTypeInfo.type);
      return displayStrings && displayStrings.displayName;
    };
  }
]);
